/* unplugin-vue-components disabled */import script from "./FoldBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./FoldBox.vue?vue&type=script&lang=ts&setup=true"

import "./FoldBox.vue?vue&type=style&index=0&id=25723d0b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25723d0b"]])

export default __exports__